import { Modal } from '@/components/Modal';
import type { ModelFile } from '@maker-toolchest/shared';
import { FilesTable } from './FilesTable';
import { useToast } from '@/components/ToastProvider';
import { useNavigate } from 'react-router-dom';

interface ModelFilesModalProps {
  open: boolean;
  onClose: () => void;
  modelId: string;
  modelName: string;
  files: ModelFile[];
}

export function ModelFilesModal({ open, onClose, modelId, modelName, files }: ModelFilesModalProps) {
  const toast = useToast();
  const navigate = useNavigate();

  const handleDownload = async (fileId: string, fileName: string) => {
    try {
      const { modelsApi } = await import('../api');
      const { url } = await modelsApi.getFileDownloadUrl(modelId, fileId);

      // Create a temporary link and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error: any) {
      toast.error(error.message || 'Failed to download file');
    }
  };

  const handleFileClick = (fileId: string) => {
    onClose(); // Close modal before navigating
    navigate(`/models/${modelId}/files/${fileId}/details`);
  };

  return (
    <Modal open={open} onClose={onClose} title={`Files - ${modelName}`} size="lg">
      <div className="space-y-4">
        <FilesTable
          modelId={modelId}
          files={files}
          onDownload={handleDownload}
          onFileClick={handleFileClick}
        />
      </div>
    </Modal>
  );
}
